<script type="application/javascript">

export default {
    data() {
        return {
            deal: null,
            plan: null,
            checkoutOpen: false,
            busy: false,
            activePlan: null,
            plansType: 'yearly',
            unlimitedPlan: {
                includes: [
                    'Co-Hosted Setup and Maintenance',
                    'Full SaaS Platform (Web & Mobile)',
                    'Custom Branding, Domain, Email, Pricing',
                    'License, Admin & User Management',
                    'Single Sign-On & Integrations',
                ],
                includes2: [
                    'Custom Links, Help Center, Support',
                    'Chat/Call Support with CEO & CTO',
                    'Use-Case and Business Model Building',
                    'License Based on Workspaces and Users',
                    'Hosting Local Data in Your Country',
                ],
            },
        };
    },
    mounted() {
        this.$eventHub.$on('toggleOpenCheckout', function () {
            this.checkoutOpen = !this.checkoutOpen;
        }.bind(this));
    },
    methods: {
        openCheckout(deal) {
            // this.deal = this.plan.id;
            this.deal = deal;
            this.checkoutOpen = true;
            dataLayer.push({
                event: 'clickOpenCheckout',
                plan: this.deal.id,
                planType: this.plansType
            });
            dataLayer.push({
                event: 'clickOpenCheckoutUnlimited',
                plan: this.deal.id,
                planType: this.plansType
            });
        },
        // sendToRegister() {
        //     let url = `http://app.startinfinity.com/register?deal=plan_unlimited_v9&price=${this.plansType}`;
        //     var newTab = window.open(url, '_blank');
        //     // Focus on the new tab
        //     newTab.focus();
        // },
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/EchoPricing.vue